import React from 'react';
import { Grid } from '@material-ui/core';

import ImageWithLightbox from '../../components/Custom/ImageWithLightbox';

const ImgListView = (props) => {
  const { images, hideFileName, width, height, objectFit } = props;
  return (
    <Grid container>
      {images?.map((image, idx) => (
        <Grid container alignItems={'center'} key={`img_${idx}_${image?.name}`} style={{ padding: '8px 0px' }}>
          {image.type.includes('image') ? (
            <Grid container>
              <Grid item md={hideFileName ? 12 : 4} key={'file-image-' + idx}>
                <ImageWithLightbox
                  thumbnailSrc={image && image.url}
                  largeSrc={image && image.url}
                  fileName={image?.name || ''}
                  width={width}
                  height={height}
                  objectFit={objectFit}
                  objectPosition="top"
                  alt="샘플 이미지"
                />
              </Grid>
            </Grid>
          ) : (
            <Grid item md={12} key={'file-image-' + idx}>
              <a
                download={image.name}
                href={image.url}
                style={{
                  display: 'flex',
                  gap: 16,
                  boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
                  width: 'fit-content',
                  padding: 8,
                  borderRadius: 8,
                }}
              >
                <img
                  src={image.url}
                  width={'20px'}
                  alt={'file-' + idx}
                  onError={(e) => {
                    e.target.src = '/images/downloadImg.png';
                  }}
                />
                {image.name || ''}
              </a>
            </Grid>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default ImgListView;
